import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import titleize from "titleize";

import "typeface-roboto";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  formlabel: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
    color: "yellow"
  },
  menu: {
    width: 200
  },
  bootstrapInput: {
    borderRadius: 4,
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "4px 4px",
    width: "calc(100% - 24px)",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    "&:focus": {
      borderColor: "gold",
      //"#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      backgroundColor: "gold"
    }
  },
  ahdFormLabel: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 12,
    color: "green"
  },
  ahdFormLabelGeslacht: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 10,
    color: "green",
    fontWeight: "700"
  },
  ahdInput: {
    fontFamily: [
      "Roboto",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',

      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ],
    fontSize: 16,
    color: "blue",
    fontWeight: "400"
  },
  ahdRoot: {
    fontSize: 18,
    color: "blue"
  }
});

class KlantForm extends React.Component {
  state = {};

  handleChange = name => event => {
    const { gebruikersNaam } = this.props;
    if (!this.state.toevoegsel) {
      this.setState({ toevoegsel: "" });
    }
    if (name === "achternaam" || name === "woonplaats" || name === "adres") {
      event.target.value = titleize(event.target.value);
      //alert(titleize(event.target.value));
    }
    if (name === "postcode" || name === "initialen") {
      event.target.value = event.target.value.replace(" ", "").toUpperCase();
      //alert(titleize(event.target.value));
    }
    if (name === "email") {
      event.target.value = event.target.value.replace(" ", "").toLowerCase();
      //alert(titleize(event.target.value));
    }
    this.setState({
      [name]: event.target.value,
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  saveWijzigingen = () => {
    if (!this.state.toevoegsel) {
      this.setState({ toevoegsel: "" });
    }

    //console.log(this.state);
    const { klant } = this.props;
    this.setState();
    klant.update(this.state);
  };

  handleChangeCheckBox = name => event => {
    const { gebruikersNaam } = this.props;
    this.setState({
      [name]: !this.state[name],
      zz_lastupdate:
        new Date().toLocaleDateString("nl-NL") +
        " " +
        new Date().toLocaleTimeString("nl-NL"),
      zz_gebruikersNaam: gebruikersNaam
    });
  };

  HaalAdresOp = (postcode, huisnummer) => {
    let that = this;

    postcode = postcode.replace(" ", "");
    var HttpClient = function() {
      this.get = function(aUrl, aCallback) {
        var anHttpRequest = new XMLHttpRequest();
        anHttpRequest.onreadystatechange = function() {
          if (anHttpRequest.readyState === 4 && anHttpRequest.status === 200)
            aCallback(anHttpRequest.responseText);
        };

        anHttpRequest.open("GET", aUrl, true);
        anHttpRequest.send(null);
      };
    };
    var client = new HttpClient();
    client.get(
     // `https://geodata.nationaalgeoregister.nl/locatieserver/free?fq=postcode:${postcode}&fq=huisnummer:${huisnummer}`,
      `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=postcode:${postcode}&fq=huisnummer:${huisnummer}`,
      function(response) {
        if (response) {
          let obj = JSON.parse(response);
          //console.log(obj)
          if (obj.response.docs[0]) {
            document.getElementById("adres").value =
              obj.response.docs[0].straatnaam;
            that.setState({ adres: obj.response.docs[0].straatnaam });
            return obj.response.docs[0].straatnaam;
          } else {
            return "Niet gevonden";
          }
        }
      }
    );
  };

  HaalPostCodeOp = (straatnaam, huisnummer, woonplaats) => {
    let that = this;
    var HttpClient = function() {
      this.get = function(aUrl, aCallback) {
        var anHttpRequest = new XMLHttpRequest();
        anHttpRequest.onreadystatechange = function() {
          if (anHttpRequest.readyState === 4 && anHttpRequest.status === 200)
            aCallback(anHttpRequest.responseText);
        };

        anHttpRequest.open("GET", aUrl, true);
        anHttpRequest.send(null);
      };
    };
    var client = new HttpClient();
    client.get(
      `https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?fq=straatnaam:${straatnaam}&fq=huisnummer:${huisnummer}&fq=woonplaatsnaam:${woonplaats}?fq=straatnaam:${straatnaam}&fq=huisnummer:${huisnummer}&fq=woonplaatsnaam:${woonplaats}`,
      function(response) {
        if (response) {
          let obj = JSON.parse(response);
          if (obj.response.docs[0]) {
            //console.log(obj.response.docs[0].postcode);
            that.setState({
              postcodelookup: null,
              postcode: obj.response.docs[0].postcode
            });
            document.getElementById("postcode").value =
              obj.response.docs[0].postcode;

            return obj.response.docs[0].weergavenaam;
          } else {
            that.setState({ postcodelookup: "Postcode niet gevonden" });

            return "Niet gevonden";
          }
        }
      }
    );
  };
  componentDidMount() {
    const editable =
      this.props.gebruikersrollen.search("admin") > -1 ||
      this.props.gebruikersrollen.search("kantoor") > -1;
    this.setState({
      disabled: !editable
    });
    if (this.props.klant) {
      this.setState({
        expanded: null,
        geslacht: this.props.klant.data.geslacht || "Man",
        woonplaats: this.props.klant.data.woonplaats || "Heemskerk"
      });
    }
  }

  render() {
    const { classes, klant } = this.props;

    // ---

    const {
      voornaam,
      tussenvoegsel,
      achternaam,
      adres,
      huisnummer,
      toevoegsel,
      postcode,
      woonplaats,
      email,
      telefoon,
      opmerking,
      initialen
    } = klant.data;

    return (
      <form className={classes.container} autoComplete="off">
        <div style={{ width: "100%" }}>
          <TextField
            disabled={this.state.disabled}
            id="initialen"
            label="Initialen"
            defaultValue={initialen || ""}
            onChange={this.handleChange("initialen")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              //shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="voornaam"
            label="Voornaam"
            className={classes.textField}
            defaultValue={voornaam || ""}
            onChange={this.handleChange("voornaam")}
            margin="normal"
            // InputProps={{
            //   disableUnderline: true,
            //   classes: {
            //     root: classes.bootstrapRoot,
            //     input: classes.bootstrapInput
            //   }
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            disabled={this.state.disabled}
            id="tussenvoegsel"
            label="Tussenvoegsel"
            defaultValue={tussenvoegsel || ""}
            className={classes.textField}
            onChange={this.handleChange("tussenvoegsel")}
            margin="normal"
            // InputLabelProps={{
            //   shrink: true,
            //   className: classes.bootstrapFormLabel
            // }}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="achternaam"
            label="Achternaam"
            defaultValue={achternaam || ""}
            onChange={this.handleChange("achternaam")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="adres"
            label="Adres"
            defaultValue={adres || ""}
            onChange={this.handleChange("adres")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="huisnummer"
            label="Huisnummer"
            defaultValue={huisnummer || ""}
            onChange={this.handleChange("huisnummer")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="toevoegsel"
            label="Toevoegsel"
            defaultValue={toevoegsel || ""}
            onChange={this.handleChange("toevoegsel")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="postcode"
            label="Postcode"
            defaultValue={postcode || ""}
            onChange={this.handleChange("postcode")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="woonplaats"
            label="Woonplaats"
            defaultValue={woonplaats || "Heemskerk"}
            onChange={this.handleChange("woonplaats")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <TextField
            required
            disabled={this.state.disabled}
            id="email"
            label="Emailadres"
            defaultValue={email || ""}
            onChange={this.handleChange("email")}
            className={classes.textField}
            margin="normal"
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
          />
          <Button
            style={{
              borderRadius: 4,
              borderSize: 2,
              borderColor: "Black",
              backgroundColor: "Green",
              color: "White"
            }}
            onClick={() =>
              this.HaalAdresOp(
                document.getElementById("postcode").value,
                document.getElementById("huisnummer").value
              )
            }
          >
            Haal adres op
          </Button>
          <Button
            style={{
              marginLeft: 30,
              borderRadius: 4,
              borderSize: 2,
              borderColor: "Black",
              backgroundColor: "Green",
              color: "White"
            }}
            onClick={() =>
              this.HaalPostCodeOp(
                document.getElementById("adres").value,
                document.getElementById("huisnummer").value,
                document.getElementById("woonplaats").value
              )
            }
          >
            Zoek postcode
          </Button>
          {this.state.postcodelookup && (
            <Button
              style={{
                backgroundColor: "Blue",
                borderColor: "White",
                borderSize: "2px",
                borderRadius: "4",
                marginRight: "15px",
                marginLeft: "15px",
                //marginTop: "10px",
                color: "white",
                fontSize: 18,
                fontWeight: "bold"
              }}
            >
              {this.state.postcodelookup}
            </Button>
          )}
        </div>
        <div style={{ width: "100%", height: "10px" }} />
        {/* // Diverse kenmerken */}
        <TextField
          required
          disabled={this.state.disabled}
          id="telefoonnummer"
          label="Telefoonnummer"
          defaultValue={telefoon || ""}
          onChange={this.handleChange("telefoon")}
          className={classes.textField}
          margin="normal"
          InputProps={{
            classes: {
              root: classes.ahdRoot,
              input: classes.ahdInput
            }
          }}
          InputLabelProps={{
            shrink: true,
            className: classes.ahdFormLabel
          }}
        />
        <FormControl
          disabled={this.state.disabled}
          className={classes.ahdformlabel}
          style={{ marginTop: "20px" }}
        >
          <FormLabel
            //component="legend"
            className={classes.ahdFormLabelGeslacht}
          >
            Geslacht
          </FormLabel>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Man"}
                  onChange={this.handleChange("geslacht")}
                  value="Man"
                  color="primary"
                />
              }
              label="Man"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.geslacht === "Vrouw"}
                  onChange={this.handleChange("geslacht")}
                  value="Vrouw"
                />
              }
              label="Vrouw"
            />
          </FormGroup>
        </FormControl>
        <div
          style={{ width: "100%", marginTop: "10px" }}
          className={classes.root}
        >
          {/* <TextField
                disabled={true}
                className={this.props.classes.textField}
                id="postcodelookup"
                label="Gevonden postcode"
                defaultValue={this.state.postcodelookup}
                //className={classes.textField}
                //style={{ marginTop: "18px", width: "100%" }}
                // onChange={this.handleChange("opmerking")}
                InputProps={{
                  classes: {
                    root: classes.ahdRoot,
                    input: classes.ahdInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.ahdFormLabel
                }}
                variant="outlined"
              /> */}

          {/* <Button
                  style={{
                    marginLeft: 20,
                    borderRadius: 4,
                    borderSize: 2,
                    borderColor: "Black",
                    backgroundColor: "Gold",
                    color: "black"
                  }}
                  onClick={() => alert(this.state.adressen)}
                >
                  Toon instellingen adressen
                </Button> */}
        </div>

        <div style={{ width: "100%" }} className={classes.root}>
          <TextField
            disabled={this.state.disabled}
            className={this.props.classes.textField}
            multiline
            rows="4"
            id="opmerking"
            label="Opmerkingen"
            defaultValue={opmerking || ""}
            //className={classes.textField}
            style={{ marginTop: "18px", width: "100%" }}
            onChange={this.handleChange("opmerking")}
            InputProps={{
              classes: {
                root: classes.ahdRoot,
                input: classes.ahdInput
              }
            }}
            InputLabelProps={{
              shrink: true,
              className: classes.ahdFormLabel
            }}
            variant="outlined"
          />
        </div>
        {/* <div style={{ width: "100%", marginTop: "20px", color: "blue" }}>
          Is een instelling ?:
        </div>
        <Divider light /> */}
        {/* <div style={{ width: "100%" }}>Hier de instelling details</div>
        <div>
          <p>&nbsp;</p>
        </div> */}

        <Paper
          style={{
            marginTop: "50px",
            marginLeft: "200px",
            marginRight: "200px"
          }}
        >
          <ul>
            De rollen admin en kantoor kunnen het formulier verder bewerken.
            Voor alle andere rollen is dit formulier op dit moment niet
            bewerkbaar
          </ul>
        </Paper>
        <Button
          variant="contained"
          //color="default"
          style={{
            backgroundColor: "green",
            color: "white",
            paddingLeft: "70%"
          }}
          onClick={this.saveWijzigingen}
        >
          Bewaar wijzigingen - sluit venster
        </Button>
      </form>
    );
  }
}

KlantForm.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(KlantForm);



// WEBPACK FOOTER //
// ./src/components/Klanten/KlantForm.jsx